import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const host = style({
  marginRight: themeVars.spacing.md,
});

export const css = {
  host,
};
